export const PROFILE_ATTRIBUTES_INHABITANT_DATA = {
  VDIV: false,
  active: true,
  bank: {
    BIC: 'GIBAATWWXXX',
    IBAN: 'AT483200000012345864',
    account_number: null,
    account_owner: null,
    active: null,
    city: null,
    code: null,
    description: null,
    name: 'Deutsche Bank',
    place: null,
  },
  claims_management: 'Klassik',
  commercial_register: 'HRB 123456',
  communication: {
    email_business: 'office@incon-vm.de',
    phone_private: null,
  },
  customer_connection: null,
  customer_type: null,
  damage_sba: null,
  employee: {
    active: true,
    last_name: null,
    name: 'TEAM WEG-Akten',
    win_name: null,
  },
  important_note: null,
  job_description: null,
  legal_form: 'Gesellschaft mit beschränkter Haftung (GmbH)',
  note: null,
  operating_mode: 'Hausverwaltung',
  supervisor: {
    active: true,
    company: null,
    email: 'stefan.kloss@incon-vm.de',
    last_name: 'Kloß',
    mobile_phone: null,
    name: 'Stefan',
    number: 'KLOSS',
    phone: '062589929220',
  },
  ust_id: 'DE123456789',
}
